import React from "react";
import CustomTitle from "@/components/custom_title";
import VideoCard from "@/components/ilmiy_faoliyat/video_card";
import { IlmiyFaoliyatWrapper } from "@/pages/ilmiy_faoliyat/style";
import Layout from "@/locales/en/layout/Layout";
import BigFotoBack from "@/components/bigFotoBack/BigFotoBack";
import { useQuery } from "react-query";
import { getMahoratDarslar } from "@/api/general";
import { useTranslation } from "react-i18next";
import bg from "../../../assets/markazlar/ilmiyFaoliyat.jpg"


function MahoratDarslar() {
  const { data } = useQuery({
    queryKey: "mahorat-darslari",
    queryFn: () => getMahoratDarslar(),
  });
  const { t } = useTranslation();
  console.log(data?.data?.data);
  return (
    <Layout>
      <IlmiyFaoliyatWrapper>
        <BigFotoBack
          img={bg}
          text={t("header.header__bottom__nav__item__menu.menu-3.item-10")}
        />
        {data?.data?.data?.map((v) => (
          <VideoCard data={v} />
        ))}

      </IlmiyFaoliyatWrapper>
    </Layout>
  );
}

export default MahoratDarslar;
